module.exports = __webpack_public_path__ + "img/b.7c246b82.jpg";